import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './style.css';
const VnValidation = ({ fieldError }) => {
    return _jsx(_Fragment, { children: fieldError && _jsx("div", { className: 'validation-error', children: fieldError.message }) });
};
export default VnValidation;
